import nes_video from '../../resources/video.mp4'
import { Link } from 'react-router-dom'
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { fetchData, fetchImage } from '../../utils/fetch';
import { Button, Divider, Flex } from 'antd';
import DisplayElements from '../../templates/display_element';

export const extractLink = (content) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, 'text/html');
    return doc.querySelector('.service').getAttribute('data-link');
};

export function Home({ catalogMenu, language, articleItems, additionalContentRef }) {
    const extractImageName = (options) => {
        const match = options.match(/s:\d+:"([^"]+\.(?:png|jpg|jpeg|gif))";/i);
        return match ? match[1] : null;
    };

    document.title = "NES";

    const [ articleImages, setArticleImages ] = useState({});
    const [ articleImagesLoaded, setArticleImagesLoaded ] = useState(false);
    const [ catalogImages, setCatalogImages ] = useState({});
    const [ imagesLoaded, setImagesLoaded ] = useState(false);
    const [ introduction, setIntroduction ] = useState({});
    const [ mainTitle, setMainTitle ] = useState({});


    const location = useLocation();
    useEffect(() => {
        if (location.state?.scrollTo === "additional") {
        setTimeout(() => {
            additionalContentRef?.current?.scrollIntoView({ behavior: 'smooth' });
        }, 100);
        }
    }, [location, additionalContentRef]);

    useEffect(() => {
        async function loadImages() {
            const newCatalogImages = {};
            setImagesLoaded(false);
            try {
                for (const catalog of catalogMenu) {
                    if (!catalog.options) continue;
                    const imageName = extractImageName(catalog.options);
                    if (catalog.id != null && imageName) {
                        const imageResponse = await fetchImage(`front/image/product_menu/${catalog.id}/${imageName}`, language);
                        if (imageResponse.ok) {
                            const imageBlob = await imageResponse.blob();
                            newCatalogImages[catalog.id] = URL.createObjectURL(imageBlob);
                        } else {
                            newCatalogImages[catalog.id] = null;
                        }
                    }
                }
                setCatalogImages(newCatalogImages);
                setImagesLoaded(true);
            } catch (error) {
                console.log("Failed to load images: " + error);
            }
        }
       async function loadArticleImages() {
            const newArticleImages = {};
            setArticleImagesLoaded(false);
            try {
                for (let i = 0; i < Math.min(3, articleItems.length); i++) {
                    const article = articleItems[i];
                    if (!article || !article.id) continue;

                    const imageResponse = await fetchImage(
                        `front/image/article/${article.id}/thumbnail.png`,
                        language,
                        { size: "thumbnail" }
                    );

                    if (imageResponse.ok) {
                        const imageBlob = await imageResponse.blob();
                        newArticleImages[article.id] = URL.createObjectURL(imageBlob);
                    } else {
                        newArticleImages[article.id] = null;
                    }
                }
                setArticleImages(newArticleImages);
                setArticleImagesLoaded(true);
            } catch (error) {
                console.log("Failed to load images:", error);
            }
        }; 
        loadImages();
        loadArticleImages();
    }, [articleItems, catalogMenu, language]);

    useEffect(() => {
        async function loadWebObjects() {
            try {
                const data = await fetchData("front/web-objects/introduction", language);
                setMainTitle(data[0]);
                setIntroduction(data[1]);
            } catch (error) {
            }
        }
        loadWebObjects();
    }, [language]);

    return (
        <div className="home">
            <div className="video-container">
                <video src={nes_video} playsInline autoPlay loop muted disablePictureInPicture></video>
                <div className="content">
                    <h1>{mainTitle.title}</h1>
                    <div dangerouslySetInnerHTML={{__html: mainTitle.content}}></div>
                    <Link to="kontakt">
                        <Button style={{fontSize: "30px", padding: "20px", marginTop:"50px"}} color="red" variant='solid'>{language === 'sk' ? "Kontaktujte Nás" : "Contact Us"}</Button>
                    </Link>
                </div>
            </div>
            <Divider></Divider>
            <div className="additional-content">
                <Flex style={{margin: "15% 4% 15% 4%"}} vertical justify='center' align='center'>
                    <h1 style={{float: 'top'}}>{introduction.title}</h1>
                    <div
                        style={{ maxWidth: 800, textAlign: "justify" }}
                        dangerouslySetInnerHTML={{ __html: introduction.content }}
                    ></div>
                </Flex>
                <Divider></Divider>
                {/* TODO rewrite into the template component */}
                <h1 ref={additionalContentRef} style={{alignSelf: "center"}}>{language === 'sk' ? "Čo ponúkame?" : "Our services"}</h1>
                <DisplayElements items={catalogMenu.filter(item => (item.parent_id === 0))} images={catalogImages} imagesLoaded={imagesLoaded} language={language}></DisplayElements>
                <Divider></Divider>
                <h1 style={{margin: "10% 10px 10px 10px", alignSelf: "center"}}>{language === 'sk' ? "Nedávne príspevky" : "Recent posts"}</h1>
                <DisplayElements items={articleItems.filter((_,index) => {return index < 3})} images={articleImages} imagesLoaded={articleImagesLoaded} language={language}/>
                <Link to={language === 'sk' ? "/novinky" : "/news"} style={{alignSelf: "center", marginTop: "20px", marginBottom: "10%"}}><Button variant="solid" color="red">{language === 'sk' ? "Viac" : "More"}</Button></Link>
            </div>
        </div>
    );
}
